module.exports = __webpack_public_path__ + "static/img_pledge_benefit-5a93c8ca6c40e01469f2738f3f50a97a.png";